import { render, staticRenderFns } from "./approve_record.vue?vue&type=template&id=301ed8bf&scoped=true"
import script from "./approve_record.vue?vue&type=script&lang=js"
export * from "./approve_record.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/approve-record.scss?vue&type=style&index=0&id=301ed8bf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301ed8bf",
  null
  
)

export default component.exports